import { createContext } from "react";
import { AnyPageDocument } from "hyam-prismic/types";

export type HyamPrismicGlobalDataProps = { page?: AnyPageDocument };

export const HyamPrismicGlobalData = createContext({
  page: undefined,
} as HyamPrismicGlobalDataProps);
